
/**
 *
 * @param url string
 * @param name string
 *
 */

const ElementNodeA = (url:string, name:(string | null) = null) => {
  const a = document.createElement('a')
  a.href = url
  name && (a.download = name)
  a.click()
  a.removeAttribute('onclick')
}

export const BaseDownLoadCsv = (name: string) => {
  var blob = new Blob(['instance_id'], { type: 'text/csv' })
  const url = URL.createObjectURL(blob)

  ElementNodeA(url, name + '.csv')
}

export const ServerDownLoad = (url:string, data: any) => {
  let params = `?`
  for (const k in data) {
    params += `${k}=${data[k]}&`
  }
  const user = JSON.parse((localStorage.getItem('user') as any))
  const token = user && user.token
  params += 'token=' + token
  const _url = `${url}${params}`

  ElementNodeA(_url)
}
